import { Jodit } from 'jodit-react';
import { onProcessPasteLink, onSubmit, onUnlink } from './link';
import { DATA_JOY_DATA } from './constants';

export type CustomLinkPluginOptions = {
  onAddLink: (jodit: Jodit, url: string, content: string, data?: string, setLoading?: (isLoading: boolean) => void) => void;
  processPastedLink?: boolean;
  processVideoLink?: boolean;
  video?: {
    parseUrlToVideoEmbed: (url: string, options: { width?: number; height?: number }) => string;
    defaultWidth: number;
    defaultHeight: number;
  };
};

type ApplyCustomLinkCommandValue = {
  url: string;
  content: string;
  data?: string;
};

export class CustomLinkPlugin {
  private jodit: Jodit;
  private options: CustomLinkPluginOptions;

  constructor(jodit: Jodit) {
    this.jodit = jodit;
  }

  init(): void {
    this.options = (this.jodit.o as any & { customLinkPlugin: CustomLinkPluginOptions }).customLinkPlugin;

    this.jodit.registerCommand('applyCustomLink', {
      exec: (_: unknown, __: string | undefined, value: ApplyCustomLinkCommandValue) => {
        this.jodit.editor.focus();
        this.jodit.editor.normalize();
        const snapshot = this.jodit.history.snapshot.make();
        onSubmit(
          this.jodit,
          value.url,
          value.content,
          snapshot,
          value.data
            ? {
                [DATA_JOY_DATA]: value.data ?? '',
              }
            : {},
        );
        return false;
      },
      hotkeys: ['ctrl+k', 'cmd+k'],
    });

    this.jodit.registerCommand('unlink', {
      exec: () => {
        this.jodit.editor.focus();
        this.jodit.editor.normalize();
        onUnlink(this.jodit, this.jodit.history.snapshot.make());
        return false;
      },
    });

    if (this.options.processPastedLink) {
      this.jodit.e.on('processPaste.link', (_: boolean, html: string) => {
        onProcessPasteLink(this.jodit, html);
      });
    }
  }

  destroy(): void {
    // Clean up any event listeners or registered commands
    this.jodit.registerCommand('openCustomLinkDialog', {
      exec: () => {},
    });
    this.jodit.registerCommand('applyCustomLink', {
      exec: () => {},
    });
    this.jodit.registerCommand('unlink', {
      exec: () => {},
    });
    this.jodit.e.off('processPaste.link');
  }
}
